import * as React from "react";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { Skeleton } from "../../skeleton/skeleton/skeleton.mjs";
import { SkeletonItem } from "../../skeleton/skeleton-item/skeleton-item.mjs";
const Radio = React.forwardRef(function Radio2(props, ref) {
  return /* @__PURE__ */ React.createElement(
    PropsChecker,
    {
      componentName: "Radio",
      componentProps: props,
      defaultValueName: "defaultChecked",
      valueName: "checked",
      onChangeNames: "onChange",
      isComponentDisabled: props.disabled
    },
    /* @__PURE__ */ React.createElement(
      AnalyticsTrigger,
      {
        trigger: {
          callback: "onChange",
          id: "Radio - Check - ".concat(props.id),
          elementId: props.id,
          elementType: "radio",
          interactionType: "check"
        }
      },
      /* @__PURE__ */ React.createElement(RadioInner, { ...props, ref })
    )
  );
});
const RadioInner = React.forwardRef(function RadioInner2(props, ref) {
  const {
    input,
    checked,
    defaultChecked,
    onChange,
    value,
    disabled,
    id = "id-0",
    labelText,
    children,
    extraContent,
    size = "large",
    direction,
    indicatorAlign,
    hideLabel,
    employee,
    className,
    helpMessage,
    errorMessage,
    successMessage,
    employeeMessage
  } = props;
  const [innerChecked, setInnerChecked] = React.useState(defaultChecked || false);
  const isChecked = onChange && typeof checked !== "undefined" ? checked : innerChecked;
  const handleChange = () => {
    if (props.disabled || isChecked) {
      return;
    }
    if (typeof props.checked === "undefined") {
      setInnerChecked(true);
    }
    if (onChange) {
      onChange(true);
    }
  };
  const BEM = () => {
    const classArray = ["radio"];
    if (size) {
      classArray.push("radio--" + size);
    }
    if (direction) {
      classArray.push("radio--" + direction);
    }
    if (indicatorAlign) {
      classArray.push("radio--indicator-" + indicatorAlign);
    }
    if (hideLabel) {
      classArray.push("radio--hide-label");
    }
    if (employee) {
      classArray.push("radio--employee");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const getInputClass = () => {
    const classArray = ["radio__input"];
    if (input == null ? void 0 : input.className) {
      classArray.push(input.className);
    }
    return classArray.join(" ");
  };
  const getAriaDescribedBy = () => {
    const arr = [];
    if (props["aria-describedby"]) {
      arr.push(props["aria-describedby"]);
    }
    if (helpMessage) {
      arr.push("".concat(id, "-help-message"));
    }
    if (errorMessage) {
      arr.push("".concat(id, "-error-message"));
    }
    if (successMessage) {
      arr.push("".concat(id, "-success-message"));
    }
    if (employeeMessage) {
      arr.push("".concat(id, "-employee-message"));
    }
    return arr.join(" ");
  };
  if ("skeleton" in props) {
    const { skeleton } = props;
    const { lineCount = 1, lineHeight, lineWidth } = skeleton;
    return /* @__PURE__ */ React.createElement(Skeleton, { className: BEM(), label: skeleton.label }, /* @__PURE__ */ React.createElement("div", { className: "radio__inner" }, /* @__PURE__ */ React.createElement(SkeletonItem, { className: "radio__indicator" }), /* @__PURE__ */ React.createElement("div", { className: "radio__content" }, [...Array(lineCount).keys()].map((_line, index) => /* @__PURE__ */ React.createElement(SkeletonItem, { key: "".concat(id, "-").concat(index), height: lineHeight, width: lineWidth })))));
  }
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ...input,
      ref,
      type: "radio",
      checked: isChecked,
      defaultChecked: void 0,
      value,
      onChange: handleChange,
      disabled,
      id,
      className: getInputClass(),
      "aria-invalid": props["aria-invalid"],
      "aria-describedby": getAriaDescribedBy()
    }
  ), /* @__PURE__ */ React.createElement("label", { htmlFor: id, className: "radio__label" }, labelText), /* @__PURE__ */ React.createElement("div", { className: "radio__inner", onClick: handleChange }, /* @__PURE__ */ React.createElement("span", { className: "radio__indicator" }), /* @__PURE__ */ React.createElement("div", { className: "radio__content", "aria-hidden": !children }, children || labelText)), helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "radio__form-helper", text: helpMessage, type: "help", id: "".concat(id, "-help-message") }), errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "radio__form-helper", text: errorMessage, type: "error", id: "".concat(id, "-error-message") }), successMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "radio__form-helper", text: successMessage, type: "valid", id: "".concat(id, "-success-message") }), employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "radio__form-helper", text: employeeMessage, type: "employee", id: "".concat(id, "-employee-message") }), extraContent && /* @__PURE__ */ React.createElement("div", { className: "radio__extra" }, extraContent));
});
export {
  Radio
};
